// Import dependencies
import { isValid, differenceInSeconds } from 'date-fns';
import { Timer } from 'easytimer.js';
import { toDate } from 'date-fns-tz';
import { initialiser } from '../../ramen-imports/utilitybelt';

import padNumberWithZeros from '../../utils/padNumberWithZeros';

class Countdown {
  constructor(config) {
    const { el } = config;

    // Set module dom elements
    this.container = el;
    this.units = {
      days: this.container.querySelector('.js-countdown-days'),
      hours: this.container.querySelector('.js-countdown-hours'),
      minutes: this.container.querySelector('.js-countdown-minutes'),
      seconds: this.container.querySelector('.js-countdown-seconds'),
    };

    // toDate keeps teh fixed timezone from craft
    this.endDate = this.container.dataset.endDate ? toDate(this.container.dataset.endDate) : null;
    this.startDate = new Date();
    this.expiredToggleClass = this.container.dataset.expiredToggle;
    this.expiredToggleTargetClass = this.container.dataset.expiredToggleTarget;
  }

  // Initialisation Function
  init = () => {
    if (isValid(this.endDate)) {
      this.timer = new Timer();

      this.timer.start({
        countdown: true,
        startValues: {
          seconds: differenceInSeconds(this.endDate, this.startDate),
        },
      });

      this.timer.addEventListener('secondsUpdated', () => {
        const {
          days, hours, minutes, seconds,
        } = this.timer.getTimeValues() || {};

        this.updateCountdownValues(days, 'days');
        this.updateCountdownValues(hours, 'hours');
        this.updateCountdownValues(minutes, 'minutes');
        this.updateCountdownValues(seconds, 'seconds');
      });

      // Expired event
      this.timer.addEventListener('targetAchieved', () => {
        // Toggle class for all expired toggles (in data-expired-toggle)
        if (this.expiredToggleClass && this.expiredToggleTargetClass) {
          [...document.querySelectorAll(this.expiredToggleClass)].forEach((el) => {
            el.classList.toggle(this.expiredToggleTargetClass);
          });
        }
      });
    }
  };

  updateCountdownValues = (value, type) => {
    let valueWrapper = null;

    if (type === 'days') {
      valueWrapper = this.units.days;
    } else if (type === 'hours') {
      valueWrapper = this.units.hours;
    } else if (type === 'minutes') {
      valueWrapper = this.units.minutes;
    } else if (type === 'seconds') {
      valueWrapper = this.units.seconds;
    }

    let valueEl = null;
    if (valueWrapper) {
      valueEl = valueWrapper.querySelector('.js-countdown-value');
    }

    if (valueWrapper && valueEl) {
      const valueStr = padNumberWithZeros(value, 2);
      const numberWrappers = [...valueEl.querySelectorAll('.js-countdown-number-wrapper')];

      // Loop digits to animate number wrappers
      valueStr.split('').forEach((digit, index) => {
        const animWrapper = numberWrappers[index];
        const animTarget = animWrapper.querySelector(`[data-index="${digit}"]`);

        animWrapper.querySelector('.js-countdown-number-scroller').style.transform = `translateY(-${animTarget.offsetTop}px)`;
      });

      // Remove digits until 2 decimcal places minumum
      if (valueStr.length < numberWrappers.length) {
        const oldDigit = numberWrappers.slice(0, numberWrappers.length - valueStr.length);
        oldDigit.remove();
      }
    }
  };
}

export default (settings) => initialiser(settings, Countdown);
